<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span class="fa fa-user-o"></span>{{ 'general.my_profile' | translate}}</div>
  </div>
  <div>
    <div *ngIf="UserForm">
      <div class="row">
        <div class="col-md-6">
          <form [formGroup]="UserForm" (ngSubmit)="saveUser(UserForm.value)" class="content">
            <div class="row margin-top-8">
              <div class="col-md-4 label">*{{ 'general.my_profile_form.firstname' | translate}}:</div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <input type="text" pInputText placeholder="{{ 'general.my_profile_form.firstname' | translate}}"
                    formControlName="Name" />
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">*{{ 'general.my_profile_form.surname' | translate}}:</div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <input type="text" pInputText placeholder="{{ 'general.my_profile_form.surname' | translate}}"
                    formControlName="Surname" />
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">*{{ 'general.my_profile_form.email' | translate}}:</div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <input type="text" pInputText formControlName="Email"
                    placeholder="{{ 'general.my_profile_form.email' | translate}}"  />
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">{{ 'general.my_profile_form.phone_number' | translate}}:</div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <input type="text" pInputText formControlName="PhoneNumber"
                    placeholder="{{ 'general.my_profile_form.phone_number' | translate}}" />
                </div>
              </div>
            </div>


            <div class="row margin-top-8" *ngIf="countryData && countryData.DatePickerFormat">
              <div class="col-md-4 label">{{ 'general.my_profile_form.date_of_birth' | translate}}:</div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-calendar 
    formControlName="DateOfBirth" 
    [dateFormat]="countryData.DatePickerFormat"
    placeholder="{{ 'general.my_profile_form.date_of_birth' | translate }}" 
    [monthNavigator]="true"
    [yearNavigator]="true" 
    yearRange="1900:2030">
</p-calendar>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">{{ 'general.my_profile_form.gender' | translate}}:</div>
              <div class="col-md-8">
                <p-dropdown [options]="genders" class="full-width" formControlName="GenderID"
                  placeholder="{{ 'general.my_profile_form.select_a_gender' | translate}}">
                </p-dropdown>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">{{ 'general.my_profile_form.preferred_language' | translate}}:</div>
              <div class="col-md-8">
                <p-dropdown [options]="languages" class="full-width" formControlName="Locale"
                  placeholder="{{ 'general.my_profile_form.preferred_language' | translate}}">
                </p-dropdown>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">{{ 'general.my_profile_form.units_of_measure' | translate}}:</div>
              <div class="col-md-8">
                <p-dropdown [options]="units" class="full-width" formControlName="UnitsOfMeasureID"
                  placeholder="{{ 'general.my_profile_form.units_of_measure' | translate}}">
                </p-dropdown>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">Two-Factor Authentication:</div>
              <div class="col-md-8">
                <button *ngIf="TFAEnabled" type="button" pButton label="Disable" [disabled]="tfaBusy" (click)="disable2FA()"></button>

                <button *ngIf="!TFAEnabled" type="button" pButton class="p-button-raised accent" label="Enable" (click)="enable2FA()"></button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-8 margin-top-16"><button pButton type="submit" class="full-width"
                  label="{{ 'general.my_profile_form.button.update_profile' | translate}}"
                  [disabled]="!UserForm.valid || busy"></button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-8 margin-top-16"><button type="button" pButton class="alternate full-width"
                  label="{{ 'general.my_profile_form.button.change_password' | translate}}"
                  (click)="changePassword()"></button>
              </div>
            </div>
            <div class="row">

            </div>
          </form>
        </div>
        <div class="col-md-6">
          <div class="content" style="width: 360px">
            <div class="row">
              <div class="col-md-12">
                <div class="sub-header margin-bottom-16">{{ "general.my_profile_form.profile_image" | translate }}</div>
              </div>
            </div>
            <div style="margin: auto;width: fit-content;position: relative; margin-bottom: 16px;" *ngIf="user">
              <div class="profile-no-image"
                *ngIf="!user.ImageURL || (user.ImageURL && user.ImageURL.indexOf('avatar1') > -1)"
                (click)="fileUpload.click()">
                <div>
                  <div class="initial">{{getInitial()}}</div>
                  <div class="upload-text">{{ 'general.my_profile_form.upload_image' | translate }}</div>
                </div>
              </div>
              <div class="profile-image" *ngIf="user.ImageURL && user.ImageURL.indexOf('avatar1') === -1"
                [ngStyle]="{'background-image': 'url('+user.ImageURL+')'}" (click)="fileUpload.click()">
              </div>
              <input #fileUpload type="file" style="display: none" (change)="updatePhoto($event)">
            </div>
          </div>
        </div>


        <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
      </div>

    </div>
  </div>
  <p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
